import React from 'react'
import withLayout from "../../../layout/withLayout";
import PartnerForm from "../form/PartnerForm";
import PropTypes from "prop-types";
import {lifecycle} from "recompose";

const AddPartner = (props) => {
    return(
        <PartnerForm {...props}/>
    )
}

AddPartner.propTypes = {
    clearState: PropTypes.func.isRequired,
}

export default lifecycle({
    componentDidMount() {
        this.props.clearState()
    }
})(withLayout(AddPartner))


// WEBPACK FOOTER //
// ./src/modules/partner/component/add/AddPartner.js